// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1XS1W","infoBtn":"quickbooks_infoBtn__3PKO4","formBox":"quickbooks_formBox__2lcac","formFooter":"quickbooks_formFooter__347_C"};